import users from 'modules/core/store/collections/users'
import type QuestionGroup from 'modules/surveys/store/models/QuestionGroup'

export const questionGroupRespondent = (questionGroup: QuestionGroup) => {
  return users.get(questionGroup.attributes.respondent_id)
}
